import React from "react";
import classnames from "classnames";
import { LightboxComponentProps } from "./types";
import { Button } from "@/components/Button";
import { FiX } from "react-icons/fi";

import "./styles.scss";

export const Lightbox = ({ open, image, onClose }: LightboxComponentProps) => {
  const classNames = classnames("lightbox", {
    "lightbox--visible": open,
  });

  const onCloseHandler = () => {
    typeof onClose === "function" && onClose();
  };

  return (
    <div
      data-testid="lightbox"
      className={classNames}>
      <div className="lightbox__container">
        <div className="lightbox__control-buttons">
          <Button
            ghost
            square
            secondary
            icon={<FiX />}
            onClick={onCloseHandler}
            ariaLabel="Close"
            dataQA="lightbox-close"
          />
        </div>
        <img
          src={image.url}
          className="lightbox__image"
          alt={image.alt}
        />
      </div>
    </div>
  );
};
